import { List } from '@mui/material'
import styled from 'styled-components'

export const OnboardChipList = styled(List).attrs(() => ({
  sx: { maxHeight: 210, overflow: 'auto', marginTop: 2 },
}))``
